// TODO: Move to ENV vars when we can support different values per ENV
const AMPLITUDE_API_KEYS = {
  dev: "42b9c809679ddc6d9b5cc46426987f42",
  safety_portal: "d36ff48d8111cee6e8581a9542458a9b",
};

const DOMAINS = {
  local: "localhost",
  safety_portal: "safetyportal.hippocraticai.com",
  safety_portal_staging: "safetyportal.staging.hippocraticdev.com",
};

class AnalyticsService {
  amplitudeApiKey: string | null = null;

  async init() {
    this.amplitudeApiKey = this.selectApiKeyBasedOnDomain();
    if (import.meta.env.VITE_IS_DEV) {
      console.log(`AMPLITUDE_KEY: ${this.amplitudeApiKey}`);
    }
    // Don't initialize Analytics if Amplitude API Key is missing
    if (!this.amplitudeApiKey || this.amplitudeApiKey === "") {
      return;
    }

    const script = document.createElement("script");
    script.src = `https://cdn.amplitude.com/script/${this.amplitudeApiKey}.js`;
    script.async = true;
    script.onload = this.initAmplitude;
    document.body.appendChild(script);
  }

  // TODO: deprecate once ENV var is available
  selectApiKeyBasedOnDomain = () => {
    if (window.location.hostname === DOMAINS.safety_portal) {
      return AMPLITUDE_API_KEYS.safety_portal;
    }
    if (window.location.hostname === DOMAINS.safety_portal_staging) {
      return AMPLITUDE_API_KEYS.dev;
    }
    // FOR LOCAL AMPLITUDE TESTING
    // if (window.location.hostname === DOMAINS.local) {
    //   return AMPLITUDE_API_KEYS.dev;
    // }

    return null;
  };

  initAmplitude = () => {
    try {
      // @ts-ignore: prop does not exist on type
      window.amplitude.init(this.amplitudeApiKey, {
        fetchRemoteConfig: true,
        autocapture: true,
      });
    } catch (error) {
      console.error(`[Analytics] init error: ${error}`);
    }
  };

  setUserId = (userId: string | undefined) => {
    if (!userId) {
      console.warn("[Analytics] setUserId no userId");
      return;
    }
    try {
      // @ts-ignore: prop does not exist on type
      window.amplitude.setUserId(userId);
      console.log(`[Analytics] set userId: ${userId}`);
    } catch (error) {
      console.error(`[Analytics] setUserId error: ${error}`);
    }
  };
}

const analyticsService = new AnalyticsService();

export default analyticsService;
